import { useNavigate, useParams } from "react-router-dom";
import MedicationSummaryCard from "../components/medications/medication-summary-card";
import MedicalRecordsSection from "../components/medical-records/medical-records-section";
import ThemedSpinner from "../components/shared/spinner";
import Typography from "../components/shared/typography";
import { useSetPageContext } from "../hooks/PageContext";
import useLoadMedications from "../hooks/useLoadMedications";
import { buildRecordDetailPath } from "#/lib/medicalRecords";

const MedicationsChildPage = () => {
  const { userId } = useParams<{ userId?: string }>();
  const navigate = useNavigate();

  const { medications, isLoading, error } = useLoadMedications(userId);
  useSetPageContext(medications);

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8 w-full">
        <ThemedSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Typography variant="h4" className="text-terracotta">
          Failed to load medications
        </Typography>
      </div>
    );
  }

  const hasMedications = medications.length > 0;

  return (
    <MedicalRecordsSection
      title="Medications"
      buttonLabel="Add Medication"
      uploadMessage={`Add medication to this user's medical records ${
        userId ?? ""
      }`}
      hasRecords={hasMedications}
      emptyTitle="No medications listed."
      emptyDescription="To add a medication take a photo of the bottle or ask the chat below to add it."
    >
      {hasMedications
        ? medications.map((med) => (
            <div
              key={med.id}
              id={`record-medication-${med.id}`}
              className="file-record-anchor block scroll-mt-24"
            >
              <MedicationSummaryCard
                medication={med}
                onClick={() => {
                  const detailPath = buildRecordDetailPath(
                    "medications",
                    med.id,
                    userId
                  );
                  if (!detailPath) return;
                  navigate(detailPath, { state: { record: med } });
                }}
              />
            </div>
          ))
        : null}
    </MedicalRecordsSection>
  );
};

export default function MedicationsPage() {
  return <MedicationsChildPage />;
}
